import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlSerializer, UrlTree } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable({ providedIn: 'root' })
export class ParametersGuard {
  constructor(
    private localizeRouterService: LocalizeRouterService,
    private serializer: UrlSerializer
  ) {}

  canActivate(route: ActivatedRouteSnapshot): UrlTree {
    if (route.params['partner']) {
      return this.serializer.parse(
        this.localizeRouterService.translateRoute(
          `/SKIHIREENTRY/partner-${route.params['partner']}/PRODUCTS?shopId=` + route.params['shopId']
        ) as string
      );
    }
    return this.serializer.parse(
      this.localizeRouterService.translateRoute(
        '/SKIHIREENTRY/PRODUCTS?shopId=' + route.params['shopId']
      ) as string
    );
  }
}
